var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Button } from "../Button";
import { Icon } from "../Icon";
// styles
import "./alert.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-alert",
    type: "default",
    dismissable: false,
};
const iconType = {
    success: "check-circle",
    warning: "exclamation",
    error: "x-circle",
    informative: "information-circle",
};
const Alert = (_a) => {
    var { title, description, actions, type, dismissable, onDismiss, className } = _a, rest = __rest(_a, ["title", "description", "actions", "type", "dismissable", "onDismiss", "className"]);
    const classList = classNames("tecma-alert", { [`${type}`]: type }, { dismissable }, className);
    return (_jsxs("div", Object.assign({ className: classList }, rest, { children: [type && type !== "default" && iconType[type] && _jsx(Icon, { iconName: iconType[type] }), _jsxs("div", { className: "alert-container", children: [_jsx("h4", { className: "alert-title", children: title }), description && _jsx("p", { className: "alert-description", children: description }), actions && _jsxs("div", { className: "alert-actions", children: [" ", actions] })] }), dismissable && onDismiss && _jsx(Button, { onClick: onDismiss, iconName: "x", color: "transparent" })] })));
};
Alert.defaultProps = defaultProps;
/**
 * A way of informing the user of important changes in a prominent way.
 */
export default React.memo(Alert);
